import { ErrorCode } from '@novachat/shared';
import { ApiError, apiCalls, createHttp } from './api.js';
import { createRealtime } from './realtime.js';
import { createSession } from './session.js';
export { ApiError } from './api.js';
export { createChat, FIRST_INDEX } from './chat.js';
export { parseJiraCommand } from './commands.js';
export { errorMessage } from './errors.js';
export { callLink, createReconnectAlarm } from './reconnect.js';
export { connectionHealth, GOOD, isWorse, WORSEN_AFTER_MS } from './health.js';
export { createLive } from './live.js';
export { mentionQuery, plainText, toEditable, toWire } from './mentions.js';
export { createPresence } from './presence.js';
export { clock, dayLabel, fullDate, sameDay } from './time.js';
export { markDeleted, mergeLatest, prependOlder, setReaction, upsertMessage, withJiraCard, withoutReply, withReply } from './messages.js';
export { standingOf } from './roles.js';
export { createRealtime } from './realtime.js';
export { ASLEEP_AFTER_MS, createSocketSleep } from './sleep.js';
export { createSession } from './session.js';
/** Everything an app needs to talk to the NovaChat API: session, REST calls and the socket. */
export function createNovaChatClient(options) {
    const http = createHttp({ baseUrl: options.apiUrl, ...(options.fetch ? { fetch: options.fetch } : {}) });
    const session = createSession({
        http,
        platform: options.platform,
        deviceName: options.deviceName,
        ...(options.refreshStore ? { refreshStore: options.refreshStore } : {}),
        ...(options.locks ? { locks: options.locks } : {}),
        ...(options.wait ? { wait: options.wait } : {}),
    });
    async function authed(method, path, body) {
        const token = await session.accessToken();
        if (!token)
            throw new ApiError(401, ErrorCode.Unauthorized, 'Signed out');
        try {
            return await http(method, path, { body, token });
        }
        catch (error) {
            if (!(error instanceof ApiError) || error.status !== 401)
                throw error;
            const fresh = await session.refresh();
            if (!fresh)
                throw error;
            return http(method, path, { body, token: fresh });
        }
    }
    return {
        session,
        api: apiCalls(authed),
        realtime(handlers) {
            return createRealtime({
                url: options.wsUrl,
                getAccessToken: () => session.accessToken(),
                refreshAccessToken: () => session.refresh(),
                onSessionEnded: () => void session.ended('expired'),
                ...(options.WebSocket ? { WebSocket: options.WebSocket } : {}),
                ...handlers,
            });
        },
    };
}
//# sourceMappingURL=index.js.map